import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, darkHero = false }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f5f1eb]">
      <Header />
      <main className={`flex-grow ${darkHero ? '' : 'pt-24'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
